import React from 'react';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import useCustomStyles from 'src/hooks/useCustomStyles';

const styles = (theme: Theme) => ({
  title: {
    height: '70px',
    lineHeight: '70px',
    textAlign: 'center',
    //width: '180px',
    overflow: 'hidden',
    display: 'block',
    color: '#fff',
  },
});

export const Logo = () => {
  const classes = useCustomStyles(styles);

  return (
    <Typography variant="h1" className={classes.title}>
      {' '}
      MMS{' '}
    </Typography>
  );
};

/*
import React from 'react';
import { styled, Typography } from '@mui/material';

const TitleStyled = styled(Typography)(({theme}) => ({
  height: '70px',
  lineHeight: '70px',
  textAlign: 'center',
  //width: '180px',
  overflow: 'hidden',
  display: 'block',
  color: theme.palette.text.primary,
}));

export const Logo = () => {
  return <TitleStyled variant="h1"> MMS </TitleStyled>;
};*/
